<template>
  <div class="main">
    <h2>Hier ist noch nix</h2>
    <h3>Aber bald. Genieße in der Zwischenzeit dieses Bild:</h3>
    <img src="@/assets/images/profile_test.png">
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
export default {
  "name": "PlaceholderView",
  data() {
    return {
      isAdmin: false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg[0].isAdmin;
    } catch(e){
      console.error(e)
    }
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 40px;
  text-align: center;
}

h2 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 24px;
}

h3 {
  font-size: 1.2rem;
  color: var(--text-secondary);
  font-weight: 500;
  margin-bottom: 40px;
}

img {
  width: 100%;
  max-width: 400px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-strong);
}
</style>
